import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { LINE_ITEM_LONG_TERM_DISCOUNT, propTypes } from '../../util/types';
import { get } from 'lodash';

import css from './BookingBreakdown.css';
import { formatMoney } from '../../util/currency';

const LineItemLongTermDiscountMaybe = props => {
  const { transaction, intl } = props;

  const unitPurchase = transaction && transaction.attributes.lineItems.find(
    item => item.code === LINE_ITEM_LONG_TERM_DISCOUNT && !item.reversal
  );

  if (!unitPurchase) {
    return null;
  }

  const { discountPercentage = 0 } = transaction.attributes.protectedData;
  
  // Calculate number of booking days from transaction protectedData
  const days = get(transaction, 'attributes.protectedData.days', {});
  const numberOfDays = (days.regular || 0) + (days.peak || 0);
  
  // Determine discount type based on number of days
  let discountLabelId = 'BookingBreakdown.longTermDiscount';
  if (numberOfDays >= 30) {
    discountLabelId = 'BookingBreakdown.longTermDiscount'; // Keep as "Long term discount" for 30+ days
  } else if (numberOfDays >= 7) {
    discountLabelId = 'BookingBreakdown.sevenDayDiscount';
  } else if (numberOfDays >= 3) {
    discountLabelId = 'BookingBreakdown.threeDayDiscount';
  }
  
  return (
    <div className={css.creditsLineItem}>
      <span className={css.totalLabel}>
        <FormattedMessage
          id={discountLabelId}
          values={{ percent: discountPercentage }}
        />
      </span>
      <span className={css.totalPrice}>{formatMoney(intl, unitPurchase.lineTotal, 1)}</span>
    </div>
  );
};

LineItemLongTermDiscountMaybe.propTypes = {
  transaction: propTypes.transaction.isRequired,
  unitType: propTypes.bookingUnitType,
};

export default LineItemLongTermDiscountMaybe;
